<template>
<div class="swaychat-row">
  <input
    autocomplete="off"
    :type="type" :name="name" ref="input" :placeholder="label" :value="value" @input="update($event.target.value)" @keypress="validKeyPress($event)" :class="{
    'swaychat-error': error
    }">
</div>
</template>


<script>
export default {
  props: [
    'label',
    'name',
    'type',
    'value',
    'error'
  ],
  methods: {
    update(v) {

      let userInput = v
      if (this.type == 'tel')
        userInput = userInput.replace(/[^0-9+]+/g, '')

      if (this.name == 'name')
        userInput = this.capitalize(userInput).replace(/[!@#$%^&*()\\/,_~\?<>:;"{}=\+\[\]\|]/gi, '').replace(/[0-9]+/g, '')

      this.$refs.input.value = userInput
      this.$emit('input', userInput.trim())

    },
    validKeyPress(e) {

      if (this.type != 'tel')
        return

      let key = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      let ch = '0123456789-+'

      if (!e.ctrlKey && ch.indexOf(key) < 0 && e.keyCode != 13)
        e.preventDefault()

    },
    capitalize(v) {
      return v.replace(/\w\S*/g, function(s) {
        return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
      })
    }
  }
}
</script>
